import { Component, Input, OnChanges } from '@angular/core';
import { doesStatusMatch } from 'src/app/core/functions/does-status-match.function';
import { EApplicationStatus, StatusCodeToString } from '../../enums/application-status.enum';
import { IApplication } from '../../models/application.model';

import { LuIconComponent } from '../lu-icon/lu-icon.component';

@Component({
    selector: 'app-status-display',
    templateUrl: './status-display.component.html',
    styleUrls: ['./status-display.component.scss'],
    imports: [LuIconComponent]
})
export class StatusDisplayComponent implements OnChanges {

  @Input() application: IApplication;

  @Input() public badgeOnly: boolean

  @Input() public showCheck: boolean;

  @Input() public showX: boolean;

  public statusText: string;

  ngOnChanges(): void {
    const statusCode = this.application?.status.statusCode;

    if (statusCode === EApplicationStatus.APPROVED &&
      this.application?.approvalType &&
      this.application?.applicationType !== this.application?.approvalType) {
      this.statusText = 'Approved as ' + this.application?.approvalType;
    } else {
      this.statusText = StatusCodeToString(statusCode)
    }

    if (!this.badgeOnly) {
      this.showCheck = doesStatusMatch(statusCode, [EApplicationStatus.AWAITING_RS_RECOMMENDATION, EApplicationStatus.APPROVED]);
      this.showX = doesStatusMatch(statusCode, [EApplicationStatus.NOT_RECOMMENDED_BY_RS, EApplicationStatus.DENIED_BY_LU_SHEPHERD, EApplicationStatus.WITHDRAWN_BY_APPLICANT, EApplicationStatus.EXPIRED]);
    }
  }
}
